import type { TOC } from '@ember/component/template-only';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import WrForm from 'ember-wiser/components/form';
import FileAttachementRow from 'parog-web/components/dialysis/edition-form/file-attachement-row';
import type DpMeasuredJournalEvent from 'parog-web/models/dp-measured-journal-event';
import type TypedEmberChangeset from 'parog-web/utils/typed-ember-changeset';
import Dropdown from 'ui-kit/components/dropdown';

interface Signature {
  Args: {
    measurement: TypedEmberChangeset<DpMeasuredJournalEvent>;
    onSubmit: () => Promise<void>;
  };
}

const BeforeSessionEditionForm: TOC<Signature> = <template>
  <WrForm @data={{@measurement}} @onSubmit={{@onSubmit}} as |form|>
    <form.InputRow
      @name='occurredAt'
      @label='Date et heure *'
      type='datetime-local'
      class='[&+span]:mt-2 [&+span]:block [&+span]:leading-[1.094rem]'
    >&nbsp;
    </form.InputRow>

    <form.InputRow
      @label='Poids du jour'
      @name='beforeWeight'
      min='0'
      type='number'
      class='mb-2 sm:mb-0'
      placeholder='Ex: 80'
    >kg</form.InputRow>

    <form.InputRow
      @label='Volume total à injecter'
      @name='beforeTotalVolumeToInject'
      min='0'
      type='number'
      class='mb-2 sm:mb-0'
      placeholder='Ex: 5'
    >L</form.InputRow>

    <form.InputRow
      @label='Pression artérielle systolique'
      @name='beforeArterialSystolicPressure'
      min='0'
      type='number'
      class='mb-2 sm:mb-0'
      placeholder='Ex: 120'
    >mmHg</form.InputRow>

    <form.InputRow
      @label='Pression artérielle diastolique'
      @name='beforeArterialDiastolicPressure'
      min='0'
      type='number'
      class='mb-2 sm:mb-0'
      placeholder='Ex: 75'
    >mmHg</form.InputRow>

    <form.InputRow
      @label='Fréquence cardiaque'
      @name='beforeHeartRate'
      min='0'
      type='number'
      class='mb-2 sm:mb-0'
      placeholder='Ex: 70'
    >bpm</form.InputRow>

    <form.InputRow
      @label='Température corporelle'
      @name='beforeBodyTemperature'
      min='0'
      type='number'
      class='mb-2 sm:mb-0'
      placeholder='Ex: 37.5'
    >°C</form.InputRow>

    <form.Row aria-label='beforeOrificeAspect'>
      <:header>Aspect de l’orifice / cathéter</:header>
      <:col1>
        <Dropdown
          @selected={{changesetGet @measurement 'beforeOrificeAspect'}}
          @onChange={{changesetSet @measurement 'beforeOrificeAspect'}}
          class='mt-2 sm:mt-0'
          as |dropdown|
        >
          {{#each beforeOrificeAspectOptions as |option|}}
            <dropdown.Item @key={{option}} @value={{option}} />
          {{/each}}
        </Dropdown>
      </:col1>
    </form.Row>

    <FileAttachementRow
      @form={{form}}
      @title='Prendre une photo de l’orifice'
    />

    <form.TextareaRow
      @label='Commentaires patient'
      @name='comments'
      class='mt-2 sm:mt-0'
      placeholder='Laisser un commentaire…'
    >
      &nbsp;
    </form.TextareaRow>
    {{! Hack: add a hidden native submit button so that
          pressing "Enter" triggers a proper HTML form submission. }}
    <button type='submit' class='hidden'></button>

  </WrForm>
</template>;

export default BeforeSessionEditionForm;

export const beforeOrificeAspectOptions = [
  'Douloureux',
  'Induration le long du tunnel',
  'Sensation de chaleur',
  'Propre et sec'
] as const;
